import { useTheme } from '@mui/material';
import { tokens, categoryColors, statusColors } from '../../themes/smartinventoryTheme';

// StatusChip/CategoryPill read colour by semantic key, never a hex prop.
// This centralises "which mode am I in" so callers never touch tokens[mode]
// or categoryColors[mode] directly.
const useDesignTokens = () => {
  const theme = useTheme();
  const mode = theme.palette.mode;
  const t = tokens[mode];
  return {
    mode,
    tokens: t,
    categoryColors: categoryColors[mode],
    statusColors: statusColors(t),
  };
};

export default useDesignTokens;
